import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter = ({ dark = false, compact = false }) => {
  const linkClass = dark
    ? 'text-white/75 hover:text-white focus-visible:text-white'
    : 'text-gray-500 hover:text-primary-600 focus-visible:text-primary-600';

  return (
    <footer className={`${compact ? 'py-5' : 'py-7'} text-center text-xs`}>
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2" aria-label="Legal and support">
        <Link className={`${linkClass} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500`} to="/privacy">Privacy</Link>
        <Link className={`${linkClass} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500`} to="/terms">Terms</Link>
        <Link className={`${linkClass} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500`} to="/data-deletion">Data Deletion</Link>
        <Link className={`${linkClass} rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500`} to="/support">Support</Link>
      </nav>
      <p className={`mt-3 ${dark ? 'text-white/55' : 'text-gray-400'}`}>
        © 2026 Texan Title Insurance Company. All rights reserved.
      </p>
    </footer>
  );
};

export default PublicFooter;
